<template>
<div class="page-root with-footer" id="customersSearch">
  <div class="horizontal-scroll" id="customersSearch-horizontal-scroll">

    <div class="jumbotron" id="customersSearch-jumbotron">
      <div class="container-fluid almost-fluid" id="customersSearch-container">
        <search-filter-bar v-model="searchFilters"
                          :relation="filters.relation"
                          :batch="filters.batch"
                          :productLine="filters.productLine"
                          :status="filters.status"
                          :loaded="loaded"
                          @filter="handleFilter"
                          id="customersSearch-searchBarFilter"
        ></search-filter-bar>
      </div>
    </div>

    <div class="cm-loader" v-if="!loaded" id="customersSearch-cmloader">
      <custom-spinner></custom-spinner>
    </div>

    <transition name="fade" mode="out-in" id="customersSearch-transition">
      <search-table v-if="loaded" :customerList="customerList"></search-table>
    </transition>

  </div>

  <pagination v-model="currentPage"
              :currentPage="currentPage"
              :pageSize="pageSize"
              :pageCount="pageCount"
              :itemCount="customerCount"
              id="customersSearch-pagination"
  ></pagination>

</div>
</template>

<script>
import RestService from '@/service/RestService.js';
import SearchFilterBar from '@/components/customers/SearchFilterBar';
import SearchTable from '@/components/customers/SearchTable';
import Pagination from '@/components/Pagination';
import CustomSpinner from '../CustomSpinner.vue';

const DEFAULT_PAGE_SIZE = 10;
const DEFAULT_PAGE = 1;

export default {
  components: { SearchFilterBar, SearchTable, Pagination, CustomSpinner },
  props: {
    page: { default: DEFAULT_PAGE },
    size: { default: DEFAULT_PAGE_SIZE },
    identifier: { default: '' },
    batch: { default: '' }
  },
  data() {
    return {
      rest: this.initRestService(),
      customerList: [],
      customerCount: null,
      pageCount: null,
      currentPage: this.page,
      pageSize: this.size,
      searchFilters: {},
      filters: {
        identifier: this.identifier,
        batch: this.batch
      },
      loaded: false
    }
  },
  beforeMount: function () {
    this.loadCustomers();
  },
  methods: {
    initRestService: function () {
      return new RestService();
    },
    async loadCustomers() {
      this.loaded = false;
      let filterObj = {};
      if (this.filters.identifier.length > 0) {
        filterObj.identifier = this.filters.identifier;
      }
      if (this.filters.batch.length > 0) {
        filterObj.batchId = (typeof this.filters.batch === 'string')
          ? this.filters.batch.split(',') : this.filters.batch;
      }
      let response = await this.rest.getCustomerList(this.currentPage, this.pageSize, filterObj);
      this.customerList = response.data.data;
      this.customerCount = response.data.meta.totalItems;
      this.pageCount = response.data.meta.totalPages;
      this.loaded = true;
    },
    buildUrl() {
      let queryString = '';
      queryString += '?page=' + this.currentPage;
      if (this.pageSize !== this.$options.props.size.default) {
        queryString += '&size=' + this.pageSize;
      }
      for (let key in this.filters) {
        let val = this.filters[key];
        if (typeof val !== 'undefined' && val.length > 0) {
          queryString += '&' + key + '=' + val;
        }
      }
      return queryString;
    },
    handleFilter() {
      this.filters = this.searchFilters;
      this.loadCustomers();
      this.updateUrl();
    },
    updateUrl() {
      this.$router.push('/customer' + this.buildUrl());
      this.$forceUpdate();
    }
  },
  watch: {
    currentPage() {
      this.loadCustomers();
      this.updateUrl();
    }
  }
}
</script>

<style lang="scss" scoped>
.jumbotron,
.pagination-container {
  padding-right: 17px !important;
  padding-left: 0 !important;
  >>> .almost-fluid > .row {
    padding: 0 .75rem;
  }
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s
}
.fade-enter, .fade-leave-to {
  opacity: 0
}
</style>



// WEBPACK FOOTER //
// src/components/customers/CustomersSearch.vue